import { createContext, useEffect, useState } from "react";
import { FavouritesPage } from "../favourites/favouritesPage";
import { SearchPage } from "../search/searchPage";
import { FiltersContext, FiltersProvider } from "../filters/filtersProvider";
import { SelectedItemsProvider } from "../selected/selectedItemsProvider";
import { collections, Course } from "./courses";
import { useLocalStorage } from "../helpers/useLocalStorage";
import { AnalyticsEvent, useAnalytics } from "../firebase/firebase";

export const subPages = ["album", "search"] as const;
export type SubPage = typeof subPages[number];

interface ILocation {
    course: Course;
    setCourse: (b: Course) => void;
    subPage: SubPage;
    setSubPage: (s: SubPage) => void;
    collection: string;
    topic: string;
    setTopic: (t: string) => void;
    subTopic: string;
    setSubTopic: (t: string) => void;
    subSubTopic: string;
    setSubSubTopic: (t: string) => void;
}

export const LocationContext = createContext<ILocation | undefined>(undefined);

export const PageChooser = () => {
    const { track } = useAnalytics();
    const [subPage, setSubPage] = useState<SubPage>("search");

    const [course, setCourse] = useLocalStorage<Course>("pagechooser.course", Course.AL_MAT);
    const [topic, setTopic] = useLocalStorage<string>("pagechooser.topic", "Topic");
    const [subTopic, setSubTopic] = useLocalStorage<string>("pagechooser.subtopic", "Subtopic");
    const [subSubTopic, setSubSubTopicStateValue] = useLocalStorage<string>("pagechooser.subsubtopic", "Subsubtopic");

    return (
        <LocationContext value={{
            collection: collections[course],
            course,
            setCourse,
            subPage,
            setSubPage,
            topic,
            subTopic,
            subSubTopic,
            setTopic,
            setSubTopic,
            setSubSubTopic: (subSubTopic: string) => {
                setSubSubTopicStateValue(subSubTopic);
                track("location.update", { //only needed here because course forces subsubtopic update
                    course: course,
                    topic: topic,
                    subTopic: subTopic,
                    subSubTopic: subSubTopic,
                })
            },
        }}>
            {
                subPage === "album"
                    ?
                    <FavouritesPage />
                    :
                    <FiltersProvider>
                        <SelectedItemsProvider>
                            <SearchPage />
                        </SelectedItemsProvider>
                    </FiltersProvider>

            }
        </LocationContext>
    )
}